import {REQUEST_CART_ITEMS,
  RECEIVE_CART_ITEMS,
  UPDATE_CART_ITEM_QTY,
  RECEIVE_PREVIOUSLY_PURCHASED_ITEMS,
  REQUEST_PREVIOUSLY_PURCHASED_ITEMS,
  REQUEST_RELATED_INK_ITEMS,
  RECEIVE_RELATED_INK_ITEMS,
  REQUEST_RELATED_MAINTENANCE_ITEMS,
  RECEIVE_RELATED_MAINTENANCE_ITEMS,
  REQUEST_SAVED_ITEMS,
  RECEIVE_SAVED_ITEMS
} from '../constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function shoppingCartReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_CART_ITEMS:
      return objectAssign({}, state, {
        isFetching: true
      });

    case RECEIVE_CART_ITEMS:
    case UPDATE_CART_ITEM_QTY:
      return objectAssign({}, state, {
        shoppingCart: action.shoppingCart,
        isFetching: false
      });

    case REQUEST_PREVIOUSLY_PURCHASED_ITEMS:
      return objectAssign({}, state, {
        isFetchingPreviouslyPurchasedItems: true
      });

    case RECEIVE_PREVIOUSLY_PURCHASED_ITEMS:
      return objectAssign({}, state, {
        previouslyPurchasedItems: action.items,
        isFetchingPreviouslyPurchasedItems: false
      });

    case REQUEST_RELATED_INK_ITEMS:
      return objectAssign({}, state, {
        isFetchingRelatedInkItems: true
      });

    case RECEIVE_RELATED_INK_ITEMS:
      return objectAssign({}, state, {
        relatedInkItems: action.items,
        isFetchingRelatedInkItems: false
      });

    case REQUEST_RELATED_MAINTENANCE_ITEMS:
      return objectAssign({}, state, {
        isFetchingRelatedMaintenanceItems: true
      });

    case RECEIVE_RELATED_MAINTENANCE_ITEMS:
      return objectAssign({}, state, {
        relatedMaintenanceItems: action.items,
        isFetchingRelatedMaintenanceItems: false
      });

    case REQUEST_SAVED_ITEMS:
      return objectAssign({}, state, {
        isFetchingSavedItems: true
      });

    case RECEIVE_SAVED_ITEMS:
      return objectAssign({}, state, {
        savedItems: action.items,
        isFetchingSavedItems: false
      });

    default:
      return state;
  }
}
